import styled from 'react-emotion'

const SectionHeader = styled.p(props => `
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  font-family: 'Roboto';
  text-transform: ${props.lower ? 'inherit' : 'uppercase'};

  @media (min-width: 800px) {
    text-align: ${props.align || 'left'};
  }
`)

export default SectionHeader



// WEBPACK FOOTER //
// ./src/components/section/SectionPreHeader.js